var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTooltip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z",
    fill: "#FDE773"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z",
    stroke: "#FDDA24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.475 12.25C23.475 10.875 22.35 9.75 20.975 9.75C20.5125 9.75 20.1 9.8875 19.725 10.1V9.75C19.725 8.375 18.6 7.25 17.225 7.25C16.1375 7.25 15.2125 7.95 14.875 8.925C14.475 8.6625 13.9875 8.5 13.475 8.5C12.1 8.5 10.975 9.625 10.975 11V12.6875C10.4 12.4125 9.77505 12.25 9.11255 12.25H8.48755V17.25C8.48755 21.3875 11.85 24.75 15.9875 24.75C20.125 24.75 23.4875 21.3875 23.4875 17.25L23.475 12.25ZM15.9875 23.5C12.5375 23.5 9.73755 20.7 9.73755 17.25V13.5625C11.125 13.85 12.1875 15.0625 12.225 16.525V17.25H12.85C13.6788 17.25 14.4737 17.5792 15.0598 18.1653C15.6458 18.7513 15.975 19.5462 15.975 20.375V21H17.225V20.375C17.225 18.1625 15.5625 16.35 13.425 16.0625C13.2964 15.0931 12.8528 14.1928 12.1625 13.5H12.225V11C12.225 10.3125 12.7875 9.75 13.475 9.75C14.1625 9.75 14.725 10.3125 14.725 11V14.75H15.975V9.75C15.975 9.0625 16.5375 8.5 17.225 8.5C17.9125 8.5 18.475 9.0625 18.475 9.75V14.75H19.725V12.25C19.725 11.5625 20.2875 11 20.975 11C21.6625 11 22.225 11.5625 22.225 12.25V17.25H22.2375C22.2375 20.7 19.425 23.5 15.9875 23.5Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTooltip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconTooltip.d3ce5503ffdc9bafd7695d1ad23a59d2.svg";